import Link from "next/link";
import { ChevronRight, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { additionalManageItems } from './menu-items';

const AdditionalManageBusinessItems = () => {
  return (
    <div className="w-full max-w-md h-[500px] flex flex-col py-2">
      {/* Items list - takes up available space */}
      <div className="flex flex-col flex-1 gap-2 overflow-y-auto">
        {additionalManageItems.map((item) => (
          <Button
            key={item.name}
            variant="ghost"
            asChild
            className="h-8 px-3 py-2 justify-between bg-slate-100 hover:bg-slate-200 rounded-lg group transition-colors mb-0.5"
          >
            <Link href={item.href}>
              <span className="text-slate-900 text-sm font-semibold text-left flex-1">
                {item.name}
              </span>
              <div className="bg-white rounded-full p-1 group-hover:bg-slate-50 transition-colors">
                <ChevronRight className="h-3 w-3 text-slate-500 group-hover:text-dashboardBlue transition-colors" />
              </div>
            </Link>
          </Button>
        ))}
      </div>

      {/* Additional Filings button - pinned to bottom */}
      <div className="mt-2">
        <Button
          variant="outline"
          className="w-full h-10 border border-slate-300 shadow-lg hover:border-dashboardBlue hover:bg-slate-50 transition-colors group"
          asChild
        >
          <Link href="/start-filing.html">
            <div className="flex items-center gap-2 text-slate-900 group-hover:text-dashboardBlue transition-colors">
              <Plus className="h-4 w-4" />
              <span className="text-sm font-medium">Additional Filings</span>
            </div>
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default AdditionalManageBusinessItems;